@import '../../new-lineup-plan-grid-shared-styles.module.less';

.plan-description {
  grid-area: @description-grid-area;
  color: var(--gray-637381);
}
